import { z } from "zod";

// Schema for a single daily data entry in the V4 report
const DailyReportDataV4Schema = z.object({
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)"),
    rooms: z.number().min(0),
    room_sold: z.number().min(0),
    daily_revenue: z.string().transform(val => parseFloat(val)),
    revpar: z.string().transform(val => parseFloat(val)),
    occupancy: z.string().transform(val => parseFloat(val)),
    available: z.number(),
});

// Schema for the total calculation in the V4 report
const DailyReportTotalV4Schema = z.object({
    rooms: z.number().min(0),
    room_sold: z.number().min(0),
    daily_revenue: z.string().transform(val => parseFloat(val)),
    revpar: z.string().transform(val => parseFloat(val)),
    occupancy: z.string().transform(val => parseFloat(val)),
    available: z.number().min(0),
});

// Main schema for the V4 API response
export const DailyReportResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(DailyReportDataV4Schema),
    total: DailyReportTotalV4Schema,
});

// Export TypeScript types inferred from the Zod schemas
export type DailyReportResponseV4 = z.infer<typeof DailyReportResponseV4Schema>;
export type DailyReportDataV4 = z.infer<typeof DailyReportDataV4Schema>;